import { render, staticRenderFns } from "./AuthorizationsStepsCreateNextPage.vue?vue&type=template&id=56e44fb7&scoped=true&"
import script from "./AuthorizationsStepsCreateNextPage.vue?vue&type=script&lang=js&"
export * from "./AuthorizationsStepsCreateNextPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e44fb7",
  null
  
)

export default component.exports